import script from "./profilePicture.vue?vue&type=script&setup=true&lang=js"
export * from "./profilePicture.vue?vue&type=script&setup=true&lang=js"

import "./profilePicture.vue?vue&type=style&index=0&id=2818ed77&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2818ed77"]])

export default __exports__